export { default as MaterialsIndexPageBreadcrumbsItem } from './MaterialsIndexPageBreadcrumbsItem';
